import { render, staticRenderFns } from "./PopupContentTextLinks.vue?vue&type=template&id=b84351f0"
import script from "./PopupContentTextLinks.vue?vue&type=script&lang=js"
export * from "./PopupContentTextLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports